/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';

import {InputReact} from 'common/components/input';
import {ValidationStatus} from 'common/components/input/types';

export const TextInput = ({placeholder, validator}) => {
  const [value, setValue] = React.useState(``);
  const [validity, setValidity] = React.useState<ValidationStatus>(ValidationStatus.Default);

  return (
    <InputReact
      placeholder={placeholder}
      type='text'
      onInput={({target}) => setValue(target.value)}
      value={value}
      validationStatus={validity}
      onBlur={() => {
        if (value.length === 0) {
          setValidity(ValidationStatus.Default);
        } else if (!validator || validator(value)) {
          setValidity(ValidationStatus.Valid);
        } else {
          setValidity(ValidationStatus.Invalid);
        }
      }}
      // @ts-ignore
      styleOverride={require(`./text-input.inline.styl`)}
    />
  );
};
